/** Masraf ve avans metinleri. Durum metinleri "kimden yanıt bekleniyor" sorusunu yanıtlar. */
export const expenses = {
  status: {
    draft: "Taslak – henüz gönderilmedi",
    pending_manager: "Yöneticinizin onayını bekliyor",
    pending_manager_viewer: "Yönetici onayını bekliyor",
    pending_finance: "Finans onayını bekliyor",
    pending_management: "Şirket yönetiminin onayını bekliyor",
    returned: "Düzeltmeniz bekleniyor",
    returned_viewer: "Çalışanın düzeltmesi bekleniyor",
    approved: "Onaylandı – ödeme bekleniyor",
    paid: "Ödendi ({date})",
    rejected: "Reddedildi",
    cancelled: "İptal edildi",
  },
  advanceStatus: {
    pending_manager: "Yöneticinizin onayını bekliyor",
    pending_manager_viewer: "Yönetici onayını bekliyor",
    pending_finance: "Finans onayını bekliyor",
    pending_management: "Şirket yönetiminin onayını bekliyor",
    approved: "Onaylandı – ödeme bekleniyor",
    paid: "Ödendi ({date}) – kapatılmayı bekliyor",
    settled: "Kapatıldı ({date})",
    rejected: "Reddedildi",
    cancelled: "İptal edildi",
  },
  approver: {
    manager: "Yönetici",
    finance: "Finans ekibi",
    /** Talep sahibi şirketteki tek finans kullanıcısıysa finans adımını şirket yöneticisi ya da İK yöneticisi onaylar (K-025). */
    management: "Şirket yönetimi (finans yerine)",
  },
  waiting: {
    person: "{name} yanıtını bekliyor",
    finance: "Finans ekibinin yanıtını bekliyor",
    management: "Şirket yöneticisinin ya da İK yöneticisinin yanıtını bekliyor",
    finance_payment: "Finans ekibinin ödemesini bekliyor",
    you_submit: "Kalemleri ekleyip göndermeniz bekleniyor",
    you_fix: "Notu okuyup düzeltmeniz ve yeniden göndermeniz bekleniyor",
    employee_fix: "{name} düzeltmesini bekliyor",
    you_settle: "Harcamalarınızı bu avansa bağlı bir masraf formuyla bildirmeniz bekleniyor",
    employee_settle: "{name} masraf formunu bekliyor",
    linked_claim: "“{title}” masraf formu ödenince avans kendiliğinden kapanacak",
  },
  timeline: {
    created: "Taslak oluşturuldu",
    submitted: "Onaya gönderildi",
    resubmitted: "Düzeltilip yeniden gönderildi",
    approved_step: "{name} onayladı",
    approved_step_delegate: "{name}, {forName} adına onayladı",
    rejected: "{name} reddetti",
    returned: "{name} düzeltme için geri gönderdi",
    paid: "{name} ödendi olarak işaretledi ({date})",
    cancelled: "İptal edildi",
    rerouted: "Onaycı değişti: artık {name} bekleniyor",
    skipped_no_manager: "Yönetici tanımlı olmadığı için onay finans ekibine geçti",
    settled_claim: "“{title}” masraf formuyla mahsup edilip kapatıldı",
    settled_note: "{name} kapattı",
    advance_requested: "Avans istendi",
  },
};
